import { BuildupTemplateArray } from "../../types/BuildupTemplateArray";
import { Template } from "../../types/Template";

const findParameters = (
  handleTemplateSelect: (template: Template) => void,
  templates: BuildupTemplateArray,
  templateId: string
) => {
  const { images, parameters, id } = templates.find(template => {
    return template.id === templateId;
  });

  if (id) {
    const imageLocation = images[0] ? images[0].location : "";

    handleTemplateSelect({
      imageLocation,
      parameters,
      templateId
    });
    return parameters;
  }

  return {};
};

export default findParameters;
